import React from 'react';
import odnrLogo from '../assets/odnr-logo.png';
import parksLogo from '../assets/cincinnati-parks-logo.jpg';
import msdgcLogo from '../assets/msdgc-logo.png';
import gworvLogo from '../assets/gworv-logo.png';
import okiLogo from '../assets/oki-logo.png';
import gphcLogo from '../assets/gphc-logo.png';
import takingRootLogo from '../assets/taking-root-logo.png';
import hcpdLogo from '../assets/hcpd-logo.png';
import usfsLogo from '../assets/usfs-logo.png';

const Sponsors = () => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 260, padding: 5 }}>
    <a href="https://ohiodnr.gov/home">
      <img src={odnrLogo} style={{ width: 200, margin: 5 }} alt="Ohio Department of Natural Resources" />
    </a>
    <a href="https://www.cincinnati-oh.gov/cincyparks/">
      <img src={parksLogo} style={{ height: 100, margin: 5 }} alt="Cincinnati Parks" />
    </a>
    <a href="https://www.msdgc.org/">
      <img src={msdgcLogo} style={{ width: 200, margin: 5 }} alt="Metropolitan Sewer District of Greater Cincinnati" />
    </a>
    <a href="https://www.groundworkorv.org/">
      <img src={gworvLogo} style={{ width: 200, margin: 5 }} alt="Groundwork Ohio River Valley" />
    </a>
    <a href="https://www.oki.org/">
      <img src={okiLogo} style={{ margin: 5, filter: 'invert(1)' }} alt="Ohio Kentucky Indiana Regional Council of Governments" />
    </a>
    <a href="https://www.greatparks.org/">
      <img src={gphcLogo} style={{ margin: 5 }} alt="Great Parks of Hamilton County" />
    </a>
    <a href="https://takingroot.info/">
      <img src={takingRootLogo} style={{ height: 100, margin: 5 }} alt="Taking Root" />
    </a>
    <a href="https://www.hamiltoncountyohio.gov/government/departments/planning_and_development">
      <img src={hcpdLogo} style={{ height: 100, margin: 5 }} alt="Hamilton County Planning and Development" />
    </a>
    <a href="https://www.fs.usda.gov/)">
      <img src={usfsLogo} style={{ height: 100, margin: 5 }} alt="US Forest Service" />
    </a>
  </div>
);

export default Sponsors;
